<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { GroupSelector } from '@client/pages/manage/groups/edit/group-selector';

  export let title = '';
  export let tooltipId = '';
  export let tooltipText = '';
  export let field = '';
  export let exclusions = false;
  export let config = {};
  export let isLastChild = false;
  export let onChange;
</script>

<div class="section" class:last={isLastChild}>
  <div class="section-info">
    <h5>
      {title}
      <Icon id={tooltipId} name="help-circle" />
      <Tooltip target={tooltipId}>{tooltipText}</Tooltip>
    </h5>
  </div>
  <div class="section-controls">
    <GroupSelector bind:config {field} {exclusions} {onChange} isClearable={false} />
  </div>
</div>

<style lang="scss" src="./group-filter.scss"></style>
